export type ApartmentRentDisplayCopy = {
  rentPrimaryText: string
  rentSecondaryText: string
}

export type ApartmentRentDisplayCopySource = {
  rentPrimaryText?: string | null
  rentSecondaryText?: string | null
}

export type ApartmentRentDisplayCopyFallbacks = ApartmentRentDisplayCopy

export function resolveApartmentRentDisplayCopy(
  apartment: ApartmentRentDisplayCopySource,
  fallbacks: ApartmentRentDisplayCopyFallbacks,
): ApartmentRentDisplayCopy {
  const rentPrimaryText = apartment.rentPrimaryText?.trim()
  const rentSecondaryText = apartment.rentSecondaryText?.trim()

  return {
    rentPrimaryText: rentPrimaryText || fallbacks.rentPrimaryText,
    rentSecondaryText: rentSecondaryText || fallbacks.rentSecondaryText,
  }
}
